import {
  CompanyPolicySubscribtionDataResponse,
  DefaultCompanyPolicyResponse,
  CompanyPolicyMiniResponse,
  EditCompanyPolicyRequest,
  CompanyPolicyResponse,
} from '@interfaces/models';
import { httpClient } from '@api/interceptors';

export async function getEmployeeProfiles(): Promise<CompanyPolicyMiniResponse[]> {
  return httpClient.get('company-policies').json();
}

export async function getEmployeeProfile(id: string): Promise<CompanyPolicyResponse> {
  return httpClient.get(`company-policies/${id}`).json();
}

export async function updateEmployeeProfile(
  id: string,
  data: EditCompanyPolicyRequest,
): Promise<void> {
  return httpClient.put(`company-policies/${id}`, { json: data }).json();
}

export async function getEmployeeProfileDefaultId(): Promise<DefaultCompanyPolicyResponse> {
  return httpClient.get('company-policies/default-policy-id').json();
}

export async function createEmployeeProfile(data: EditCompanyPolicyRequest): Promise<void> {
  return httpClient.post('company-policies', { json: data }).json();
}

export async function getEmployeeProfileServicesConfig(): Promise<CompanyPolicySubscribtionDataResponse> {
  return httpClient.get('company-policies/general-subscription-data').json();
}

export async function deleteEmployeeProfile(id: string): Promise<void> {
  return httpClient.delete(`company-policies/${id}`).json();
}
